import { useCallback } from 'react'

import { callAuthorizedGraphQLEndpoint } from 'Module/graphQL'

export async function editInventoryItems(input) {
  const query = `mutation ($input: [editInventoryItemsInput]) {
    editInventoryItems(input: $input){
      id
      tag		
      description
    }
  }`

  return callAuthorizedGraphQLEndpoint(query, {
    input,
  })
}

export const useInventoryRequests = cityId => {
  const editInventoryItem = useCallback(async item => {
    const response = await editInventoryItems([item])
    const result = await response.json()

    return result.data
  }, [])

  return {
    editInventoryItem,
  }
}



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Inventory/gql/index.js